import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { screenInfoModals } from './ScreenInfo'
import * as React from 'react'
import { useStuartMutate } from '../../../APIs/Hooks/PhpAPIHooks'
import { useMessagePopupContext } from '../../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useNavigate, useParams } from 'react-router-dom'

function ConfirmDeleteDialog({
  open,
  setOpen,
}: {
  open: screenInfoModals | undefined
  setOpen: any
}) {
  const { screen_id } = useParams()
  const { setMessage } = useMessagePopupContext()
  const navigate = useNavigate()

  const { mutate: deleteScreen } = useStuartMutate(
    `/screen/deleteScreen.php?ScreenID=${screen_id}`,
    async (data) => {
      if (data?.message) {
        setMessage({
          subject: 'Error',
          severity: 'warning',
          message: data.message,
        })
      } else {
        navigate('/stuart/health/manage')
      }
    },
  )

  return (
    <Dialog
      open={open === screenInfoModals.DELETE}
      onClose={() => setOpen(undefined)}
    >
      <DialogTitle>{'Confirm Delete'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          The current screen request and any related collections will be updated
          deleted. This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(undefined)}
          color="error"
        >
          Cancel
        </Button>
        <Button
          onClick={() => deleteScreen()}
          color="warning"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDeleteDialog
